<template>
    <div class="content">
        <div class="cards-container">
            <div class="container-footer">
                <div class="card-item">
                    <div class="card">
                        <div class="avatar" style="background-image: url(//d1aettbyeyfilo.cloudfront.net/fundamentals/28601737_1654597939J69Stefan_Irimia.webp)"></div>
                        <div class="icon">
                            <icon-quote/>
                        </div>
                        <div class="header">
                            <div class="header-name">
                                Ștefan Irimia
                            </div>
                            <div class="header-description">
                                Cofondator All About Parenting
                            </div>
                        </div>
                        <div class="description">
                            Îmi conduc afacerile prin sistemul TBF de mai mult de 5 ani. Deși colegii mei sunt în România, acest model de management <b>mi-a permis să locuiesc în Spania și Marea Britanie fără să pierd controlul afacerilor. </b>
                        </div>
                    </div>
                </div>
                <div class="card-item">
                    <div class="card">
                        <div class="avatar" style="background-image: url(//d1aettbyeyfilo.cloudfront.net/fundamentals/28601727_1654597901VAsDan_Pastiu.webp)"></div>
                        <div class="icon">
                            <icon-quote/>
                        </div>
                        <div class="header">
                            <div class="header-name">
                                Dan Paștiu
                            </div>
                            <div class="header-description">
                                Fondator Franciza Dabo Doner
                            </div>
                        </div>
                        <div class="description">
                            <b>Conducem fără micromanagement peste 1000 de angajați </b>în România, Ungaria și Marea Britanie. Totul datorită sistemului de management și metodologiei de business create de Răzvan Căzănescu. 
                        </div>
                    </div>
                </div>
                <div class="card-item">
                    <div class="card">
                        <div class="avatar" style="background-image: url(//d1aettbyeyfilo.cloudfront.net/fundamentals/28601732_16545979192SWQ9CsR4ncqbrD3228hfNdNRlGVL13ecC34RuUSN9k_1.webp)"></div>
                        <div class="icon">
                            <icon-quote/>
                        </div>
                        <div class="header">
                            <div class="header-name">
                                Octavian Blăjan
                            </div>
                            <div class="header-description">
                                Fondator Euroteam Spedition
                            </div>
                        </div>
                        <div class="description">
                            Folosind sistemele TBF de management create de Răzvan Căzănescu am putut <b>să dublăm cifra de afaceri an de an până la 10 Milioane de Euro</b>. Iar în 2022 suntem din nou în grafic să dublăm. 
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="questions">
            <div class="questions-container">

                <div class="question-card">
                    <div class="icon" v-if="$resize && $mq.above(501)"><icon-question/></div>
                    <div class="question-info">
                        <div class="question">
                            <span class="icon-inline" v-if="$resize && $mq.below(500)"><icon-question/></span>
                            Cât timp am acces la curs și la 30 Days MBA?
                        </div>
                        <div class="answer">
                            Ai acces pe viață la toate materialele și bonusurile incluse în curs. Acestea includ: înregistrările video pentru cele 6 module ale cursului; șabloanele, schițele, exemplele și procesele necesare pentru implementare; cele 30 de înregistrări video din 30 Days MBA.
                        </div>
                    </div>
                </div>

                <div class="question-card">
                    <div class="icon" v-if="$resize && $mq.above(501)"><icon-question/></div>
                    <div class="question-info">
                        <div class="question">
                            <span class="icon-inline" v-if="$resize && $mq.below(500)"><icon-question/></span>
                            Cum pot să plătesc?
                        </div>
                        <div class="answer">
                            Recomandarea noastră este să achiți online cu cardul. Folosim cel mai mare și mai sigur procesator de plăți din lume <a href="https://stripe.com/en-gb-ro" target="_blank">stripe.com</a>. În acest fel primești acces instantaneu la toate materialele. Însă avem și opțiunea de plată prin OP. Diferența este însă că vei primi acces la curs în 24 de ore de la confirmarea plății. Asta poate dura între 48 și 72 de ore în funcție de bancă.
                        </div>
                    </div>
                </div>

                <div class="question-card">
                    <div class="icon" v-if="$resize && $mq.above(501)"><icon-question/></div>
                    <div class="question-info">
                        <div class="question">
                            <span class="icon-inline" v-if="$resize && $mq.below(500)"><icon-question/></span>
                            Când primesc acces la curs, șabloane și bonusuri?
                        </div>
                        <div class="answer">
                            Imediat după ce ai finalizat procesul de plată primești acces instantaneu la modulele cursului, toate șabloanele și cele 30 de lecții din 30 Days MBA. Dacă însă alegi plata prin OP vei primi acces în 24 de ore de confirmarea plății.
                        </div>
                    </div>
                </div>

                <div class="question-card">
                    <div class="icon" v-if="$resize && $mq.above(501)"><icon-question/></div>
                    <div class="question-info">
                        <div class="question">
                            <span class="icon-inline" v-if="$resize && $mq.below(500)"><icon-question/></span>
                            Cum primesc factura?
                        </div>
                        <div class="answer">
                            Dacă plătești online (recomandat) factura va fi emisă automat și trimisă pe adresa de email folosită la cumpărare. Dacă alegi să plătești prin OP vei primi factura in maximum 7 zile de la confirmarea plății.
                        </div>
                    </div>
                </div>

                <div class="question-card">
                    <div class="icon" v-if="$resize && $mq.above(501)"><icon-question/></div>
                    <div class="question-info">
                        <div class="question">
                            <span class="icon-inline" v-if="$resize && $mq.below(500)"><icon-question/></span>
                            Sistemul TBF de Management se pretează pentru munca la distanță?
                        </div>
                        <div class="answer">
                            Având în vedere că Răzvan locuiește de peste 8 ani de zile pe malul mării în Spania și vine rar în România, putem spune cu siguranță că da. Sunt zeci de antreprenori care i-au urmat exemplul și s-au mutat împreună cu familiile în locuri frumoase din lume. Chiar de multe ori Răzvan recomandă antreprenorilor care au probleme cu micromanagementul să se mute la distanță de birourile afacerii.
                        </div>
                    </div>
                </div>

                <div class="question-card">
                    <div class="icon" v-if="$resize && $mq.above(501)"><icon-question/></div>
                    <div class="question-info">
                        <div class="question">
                            <span class="icon-inline" v-if="$resize && $mq.below(500)"><icon-question/></span>
                            Pot da acces și managerilor mei?
                        </div>
                        <div class="answer">
                            Poți împărtăși contul tău cu până la 10 alți utilizatori. Însă recomandarea noastră este ca după ce liderul companiei a urmărit cursul și l-a înțeles, să urmărească încă o data întreg curriculum-ul împreună cu top managerii și angajații importanți.
                        </div>
                    </div>
                </div>

                <div class="question-card">
                    <div class="icon" v-if="$resize && $mq.above(501)"><icon-question/></div>
                    <div class="question-info">
                        <div class="question">
                            <span class="icon-inline" v-if="$resize && $mq.below(500)"><icon-question/></span>
                            Cum știu că acest sistem de management funcționează pentru compania mea?
                        </div>
                        <div class="answer">
                            Răzvan a implementat personal sistemul de management în peste 300 de companii din 23 de industrii. Apoi peste 1,000 de companii românești de la 5 angajați și până la 5,000 au preluat sistemul și l-au folosit cu succes. În acest moment principiile TBF sunt folosite în peste 200 de subindustrii. Crede-ne pe cuvânt că atât timp cât lucrezi cu oameni acest sistem va funcționa.
                        </div>
                    </div>
                </div>

                <div class="question-card">
                    <div class="icon" v-if="$resize && $mq.above(501)"><icon-question/></div>
                    <div class="question-info">
                        <div class="question">
                            <span class="icon-inline" v-if="$resize && $mq.below(500)"><icon-question/></span>
                            Cât durează implementarea sistemului TBF de management?
                        </div>
                        <div class="answer">
                            Antreprenorii disciplinați și dedicați pot implementa întreg sistemul de management într-un an de zile. Asta înseamnă că peste 12 luni vei putea să îți conduci afacerea cu doar 1 zi pe săptămână petrecută pe management. Însă pentru o parte dintre antreprenori durează între 3 și 4 ani. Motivul? Ori nu urmăresc programul de implementare predat în curs. Ori aleg doar ce le place din sistem și nu implementează toate procesele. Important este să nu uiți că este un SISTEM de management, nu un set de tactici. 
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import IconQuote from '../Icons/Quote'
    import IconQuestion from '../Icons/Question'

	export default {
		data() {
			return {
			}
		},
		components: {
            IconQuote,
            IconQuestion
		},
		mounted() {
		},
		methods: {
		}
	};
</script>

<style lang="scss">
    @import "../../scss/_footer.scss";
</style>

    